<template>
    <b-modal content-class="argus-glass-dialog"
        v-model="show"
        title="Согласование заявки"
        size="md"
        centered
        scrollable
        hide-footer
        :hide-header-close="loading"
        :no-close-on-backdrop="loading"
        :no-close-on-esc="loading"
    >
        <b-alert variant="success" show class="mb-3">
            <i class="fas fa-check-circle mr-2" aria-hidden="true"></i>
            Заявка будет переведена на следующий этап согласования или передана исполнителям.
        </b-alert>

        <b-form-checkbox
            v-if="!required"
            v-model="includeComment"
            :disabled="loading"
            @change="onIncludeCommentChange"
        >
            Добавить комментарий к согласованию
        </b-form-checkbox>

        <b-form-group
            v-if="required || includeComment"
            :label="required ? 'Комментарий к согласованию *' : 'Комментарий к согласованию'"
            label-for="approve-comment"
            class="mt-3 mb-0"
            invalid-feedback="Введите комментарий к согласованию"
            :state="commentState"
        >
            <DiscussionEditor
                id="approve-comment"
                ref="commentInput"
                v-model="comment"
                placeholder="Введите комментарий к согласованию…"
                :disabled="loading"
                :state="commentState"
            />
            <div class="approve-comment-help">
                <small class="text-muted">
                    Введённый текст сохранится при закрытии этого окна.
                </small>
                <b-button
                    variant="outline-secondary"
                    size="sm"
                    :disabled="loading || !comment"
                    @click="clearComment"
                >
                    <i class="fas fa-eraser mr-1" aria-hidden="true"></i>
                    Очистить
                </b-button>
            </div>
        </b-form-group>

        <div class="approve-modal-footer mt-4">
            <b-button
                variant="outline-secondary"
                :disabled="loading"
                @click="close"
            >
                Отмена
            </b-button>
            <b-button
                variant="success"
                :disabled="!isValid || loading"
                @click="confirm"
            >
                <b-spinner v-if="loading" small class="mr-1"></b-spinner>
                {{ loading ? 'Согласование…' : 'Согласовать' }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'ApproveModal',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            includeComment: false,
            comment: ''
        };
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(value) {
                if (!this.loading) this.$emit('input', value);
            }
        },
        trimmedComment() {
            return String(this.comment || '').trim();
        },
        isValid() {
            return this.required
                ? this.trimmedComment.length > 0
                : (!this.includeComment || this.trimmedComment.length > 0);
        },
        commentState() {
            if (!this.required && !this.includeComment) return null;
            return this.trimmedComment.length > 0 ? true : false;
        }
    },
    watch: {
        value(isOpen) {
            if (isOpen && this.required) {
                this.includeComment = true;
                this.focusComment();
            }
        },
        required(value) {
            if (value) this.includeComment = true;
        }
    },
    methods: {
        focusComment() {
            this.$nextTick(() => {
                const input = this.$refs.commentInput;
                if (input && typeof input.focus === 'function') input.focus();
            });
        },
        onIncludeCommentChange(value) {
            if (value) this.focusComment();
        },
        clearComment() {
            if (this.loading || !this.comment) return;
            this.comment = '';
            this.focusComment();
        },
        close() {
            if (!this.loading) this.$emit('input', false);
        },
        confirm() {
            if (!this.isValid || this.loading) return;
            this.$emit('confirm', this.required || this.includeComment ? this.trimmedComment : null);
        },
        reset() {
            this.includeComment = this.required;
            this.comment = '';
        }
    }
};
</script>

<style scoped>
.approve-comment-help,
.approve-modal-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
}

.approve-comment-help {
    align-items: flex-start;
    margin-top: 0.45rem;
}

.approve-comment-help small {
    line-height: 1.35;
}

@media (max-width: 575.98px) {
    .approve-comment-help {
        align-items: stretch;
        flex-direction: column;
    }

    .approve-comment-help .btn {
        align-self: flex-start;
    }
}
</style>
